"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiCircularProgressOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        circle: {
            strokeWidth: 2,
        },
        colorSecondary: {
            color: palette.type === "dark" ? palette.grey[800] : palette.grey[400],
        },
    });
};
//# sourceMappingURL=MuiCircularProgress.js.map